import ApiService from '@/services/core/api.service'

const VehicleCategoryService = {
  async get (query) {
    return ApiService.get(`senior-mechanic/maintenance-vehicle-categories?${query}`)
  },

  async post (payload) {
    return ApiService.post('senior-mechanic/maintenance-vehicle-categories', payload)
  },

  async put (payload) {
    return ApiService.put(`senior-mechanic/maintenance-vehicle-categories/${payload.id}`, payload)
  }
}

export default VehicleCategoryService
